import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import { api_gateway } from '../../../conexoes/api'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'

export default function SelectParametro(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [lsParametro, setLsParametro] = useState()
  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleParametro(
    cdAutEventoParametro,
    cdAutEventoParametroValor,
    dsParametro,
    dsValor
  ) {
    props.setCdAutEventoParametro(cdAutEventoParametro)
    props.setCdAutEventoParametroValor(cdAutEventoParametroValor)
    props.setDsParametro(dsParametro)
    props.setDsValor(dsValor)
    handleCancelar()
  }

  function handleCancelar() {
    props.setRevelarSelectParametro(false)
  }

  useEffect(() => {
    setSpinAtivo(true)
    async function renderParametro() {
      const { data } = await api_gateway.get(
        '/m1/consultar/aut_evento_parametro?cd_aut_evento=' + props.cdAutEvento
      )
      if (data.dados.length > 0) {
        let objetoParametro = data.dados.map((item, i) => {
          return (
            <li key={'menu-' + item.cd_aut_evento_parametro}>
              <div
                className="campo-select-opcao campo-select-opcao-2 campo-select-opcao-automacao"
                onClick={() =>
                  handleParametro(
                    item.cd_aut_evento_parametro,
                    item.cd_aut_evento_parametro_valor,
                    item.PARAMETRO,
                    item.ds_valor
                  )
                }
              >
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  {item.PARAMETRO}
                </span>
              </div>
              {data.dados[i + 1] != undefined && (
                <div className="campo-select-divisor-cor-1 campo-select-divisor" />
              )}
            </li>
          )
        })
        setLsParametro(objetoParametro)
      } else {
        let objetoParametro = () => {
          return (
            <li>
              <div disabled className="campo-select-opcao campo-select-opcao-1">
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  Nenhuma informação encontrada
                </span>
              </div>
            </li>
          )
        }
        setLsParametro(objetoParametro)
      }
      setSpinAtivo(false)
    }
    renderParametro()
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <Button
        name="cdTipoPessoa"
        className="campo-texto-cor-3 campo-select"
        onClick={() => props.setRevelarSelectParametro(false)}
      >
        <div className="fonte-cor-1 label-campo">{props.dsParametro}</div>
        <img
          className="campo-select-icone-ativado"
          src={setaDropdown()}
          alt="drop"
        />
      </Button>
      <div className="campo-select-triangulo-cor-1 campo-select-triangulo-position-fixed" />
      <div className="campo-texto-cor-3 campo-select-corpo-position-fixed width-250px">
        <ul className="campo-select-lista">{lsParametro}</ul>
      </div>
    </Form>
  )
}
